// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldClickable } from "@insite/mobius/FormField";
import { createAccountStyles } from "@turnerBlueprint/Overrides/Widgets/CreateAccount/CreateAccount";
import { color, hideElement, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

createAccountStyles.userGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

createAccountStyles.userGridContainer = {
    gap: 22,
    css: css`
        &&& {
        }
    `,
};

createAccountStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

createAccountStyles.passwordIcon = createAccountStyles.confirmPasswordIcon = {
    css: css`
        &&& {
            width: 37px;
        }
    `,
};

createAccountStyles.passwordTextField = createAccountStyles.confirmPasswordTextField = {
    cssOverrides: {
        formInputWrapper: css`
            ${FormFieldClickable} {
                &:not(:disabled):hover {
                    & > span {
                        color: ${color("common.ui9")};
                    }
                }
            }
        `,
    },
};

createAccountStyles.reCaptchaGridItem = {
    width: 12,
    css: css`
        &:empty {
            ${hideElement}
        }
    `,
};

createAccountStyles.requirementsGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

createAccountStyles.mainGridContainer = {
    offsetCss: css`
        ${xScreen("gt", "lg")} {
            gap: 30px;
        }
    `,
};

createAccountStyles.submitButton = {
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

createAccountStyles.separator = {
    width: 12,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        width: 100%;
    `,
};

createAccountStyles.quarterWidthItem = {
    width: [6, 6, 6, 2, 2],
};

createAccountStyles.subscriptionGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0;
    `,
};

createAccountStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

createAccountStyles.halfWidthItem = {
    width: [12, 12, 12, 6, 6],
};

createAccountStyles.fakeItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

createAccountStyles.link = {
    typographyProps: {
        size: 12,
    },
};

createAccountStyles.tippyPopup = {
    main: {
        css: css`
            &.tippy-box {
                border: 1px solid ${color("common.border")};
            }
        `,
    },
};
